(function () {
  "use strict";

  var body = document.body;

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function setAriaHidden(element, hidden) {
    element.setAttribute("aria-hidden", String(hidden));
  }

  function openDrawer(drawer, overlay) {
    setAriaHidden(drawer, false);
    overlay.classList.add("is-visible");
    body.classList.add("drawer-open");
  }

  function closeDrawer(drawer, overlay) {
    setAriaHidden(drawer, true);
    overlay.classList.remove("is-visible");
    body.classList.remove("drawer-open");
  }

  function initMobileMenu() {
    var drawer = qs("[data-mobile-drawer]");
    var overlay = qs(".mobile-drawer__overlay");
    if (!drawer || !overlay) return;

    qsa("[data-menu-open]").forEach(function (button) {
      button.addEventListener("click", function () {
        openDrawer(drawer, overlay);
      });
    });

    qsa("[data-menu-close]").forEach(function (button) {
      button.addEventListener("click", function () {
        closeDrawer(drawer, overlay);
      });
    });

    overlay.addEventListener("click", function () {
      closeDrawer(drawer, overlay);
    });
  }

  function initCartDrawer() {
    var drawer = qs("[data-cart-drawer]");
    var overlay = qs(".cart-drawer__overlay");
    if (!drawer || !overlay) return;

    qsa("[data-cart-open]").forEach(function (button) {
      button.addEventListener("click", function () {
        openDrawer(drawer, overlay);
      });
    });

    qsa("[data-cart-close]").forEach(function (button) {
      button.addEventListener("click", function () {
        closeDrawer(drawer, overlay);
      });
    });

    overlay.addEventListener("click", function () {
      closeDrawer(drawer, overlay);
    });
  }

  function initAccordions() {
    qsa("[data-accordion]").forEach(function (accordion) {
      qsa("[data-accordion-trigger]", accordion).forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var item = trigger.closest(".faq-item");
          var panel = qs("[data-accordion-panel]", item);
          var isOpen = item.classList.contains("is-open");

          qsa(".faq-item.is-open", accordion).forEach(function (openItem) {
            openItem.classList.remove("is-open");
            qs("[data-accordion-panel]", openItem).style.display = "none";
          });

          if (!isOpen) {
            item.classList.add("is-open");
            panel.style.display = "block";
          }
        });
      });
    });
  }

  function initQuantityControls() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-qty-plus], [data-qty-minus]");
      if (!button) return;

      var wrapper = button.closest(".quantity");
      var input = qs("input[type='number']", wrapper);
      if (!input) return;

      var current = parseInt(input.value || "0", 10);
      var next = button.hasAttribute("data-qty-plus") ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    document.addEventListener("change", function (event) {
      var input = event.target;
      if (!input.matches(".quantity input[type='number']")) return;

      var form = input.closest("form[action]");
      if (!form) return;

      var url = form.getAttribute("action");
      if (!url || url.indexOf("/cart") === -1) return;
      form.submit();
    });
  }

  function initGallery() {
    qsa("[data-product-gallery]").forEach(function (gallery) {
      var slides = qsa(".gallery-slide", gallery);
      var thumbs = qsa(".gallery-thumbs button", gallery);
      if (!slides.length) return;

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener("click", function () {
          var mediaId = thumb.getAttribute("data-thumb");
          var slideIndex = parseInt(thumb.getAttribute("data-thumb-index") || String(index), 10);
          var target = null;

          if (mediaId) {
            target = qs('[data-media-id="' + mediaId + '"]', gallery);
          } else if (!isNaN(slideIndex) && slides[slideIndex]) {
            target = slides[slideIndex];
          }

          if (!target) return;

          slides.forEach(function (slide) {
            slide.classList.remove("is-active");
          });
          thumbs.forEach(function (item) {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });

          target.classList.add("is-active");
          thumb.classList.add("is-active");
          thumb.setAttribute("aria-pressed", "true");
        });
      });
    });

    qsa("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var mainImage = qs(".product-spotlight__gallery .gallery-main img");
        if (!mainImage) return;

        mainImage.src = thumb.getAttribute("data-image");
        mainImage.alt = thumb.getAttribute("data-alt") || mainImage.alt;
        qsa("[data-gallery-thumb]").forEach(function (item) {
          item.classList.remove("is-active");
          item.setAttribute("aria-pressed", "false");
        });
        thumb.classList.add("is-active");
        thumb.setAttribute("aria-pressed", "true");
      });
    });
  }

  function initProductVariants() {
    qsa("[data-product-form]").forEach(function (form) {
      var jsonScript = qs("[data-product-json]", form.closest("section") || document);
      if (!jsonScript) return;

      var product = null;
      try {
        product = JSON.parse(jsonScript.textContent);
      } catch (error) {
        return;
      }

      if (!product || !product.variants) return;

      var idInput = qs("[data-variant-id]", form);
      var optionInputs = qsa("input[type='radio'][data-variant-option]", form);
      if (!idInput || !optionInputs.length) return;
      var priceCurrent = qs("[data-price-current]", form.closest("section") || document);
      var addToCartLabel = qs("[data-add-to-cart-label]", form);

      function applyGalleryColor(color) {
        var gallery = qs("[data-product-gallery]");
        if (!gallery || !color) return;

        var slides = qsa(".gallery-slide", gallery);
        var thumbs = qsa(".gallery-thumbs button", gallery);
        var normalized = String(color).toLowerCase();

        slides.forEach(function (slide) {
          var matches = !slide.getAttribute("data-gallery-color") || slide.getAttribute("data-gallery-color") === normalized;
          slide.hidden = !matches;
          if (!matches) slide.classList.remove("is-active");
        });

        thumbs.forEach(function (thumb) {
          var matches = !thumb.getAttribute("data-thumb-color") || thumb.getAttribute("data-thumb-color") === normalized;
          thumb.hidden = !matches;
          if (!matches) thumb.classList.remove("is-active");
        });

        var firstSlide = slides.find(function (slide) {
          return !slide.hidden;
        });
        var firstThumb = thumbs.find(function (thumb) {
          return !thumb.hidden;
        });

        if (firstSlide) firstSlide.classList.add("is-active");
        if (firstThumb) firstThumb.classList.add("is-active");
      }

      function selectedOptions() {
        var values = {};
        optionInputs.forEach(function (input) {
          if (input.checked) {
            values["option" + input.getAttribute("data-variant-option")] = input.value;
          }
        });
        return values;
      }

      function optionName(option) {
        return String(typeof option === "string" ? option : option.name || "").toLowerCase();
      }

      function matchVariant() {
        var selected = selectedOptions();
        return product.variants.find(function (variant) {
          return product.options.every(function (option, index) {
            var optionKey = "option" + (index + 1);
            return String(variant[optionKey]) === String(selected[optionKey]);
          });
        });
      }

      function updatePrice(variant) {
        if (!priceCurrent || variant.price == null) return;
        priceCurrent.textContent = "$" + (Number(variant.price) / 100).toFixed(2);
      }

      function updateAddToCartLabel(selected) {
        if (!addToCartLabel) return;

        var packIndex = product.options.findIndex(function (option) {
          return optionName(option) === "pack size";
        });
        var packValue = packIndex >= 0 ? selected["option" + (packIndex + 1)] : "";
        var packCount = parseInt(String(packValue).match(/\d+/), 10);

        addToCartLabel.textContent = packCount > 1 ? "Add " + packCount + " scissors to cart" : "Add to cart";
      }

      optionInputs.forEach(function (input) {
        input.addEventListener("change", function () {
          var matching = matchVariant();
          if (!matching) return;

          idInput.value = matching.id;
          updatePrice(matching);
          var selected = selectedOptions();
          var colorIndex = product.options.findIndex(function (option) {
            var name = optionName(option);
            return name === "color" || name === "colour";
          });
          if (colorIndex >= 0) {
            applyGalleryColor(selected["option" + (colorIndex + 1)]);
          }
          updateAddToCartLabel(selected);
          qsa(".variant-swatch", input.closest(".variant-picker")).forEach(function (swatch) {
            swatch.classList.remove("is-selected");
          });
          input.closest(".variant-swatch").classList.add("is-selected");
        });
      });

      var selected = selectedOptions();
      var colorIndex = product.options.findIndex(function (option) {
        var name = optionName(option);
        return name === "color" || name === "colour";
      });
      if (colorIndex >= 0) {
        applyGalleryColor(selected["option" + (colorIndex + 1)]);
      }
      updateAddToCartLabel(selected);
    });
  }

  function initHeader() {
    var header = qs("[data-header]");
    if (!header) return;

    var last = window.scrollY;
    window.addEventListener(
      "scroll",
      function () {
        var current = window.scrollY;
        if (current > 120 && current > last) {
          header.classList.add("is-hidden");
        } else {
          header.classList.remove("is-hidden");
        }
        last = current;
      },
      { passive: true }
    );
  }

  function initSmoothAnchors() {
    qsa('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener("click", function (event) {
        var id = anchor.getAttribute("href");
        if (!id || id === "#") return;
        var target = document.querySelector(id);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileMenu();
    initCartDrawer();
    initAccordions();
    initQuantityControls();
    initGallery();
    initProductVariants();
    initHeader();
    initSmoothAnchors();
  });
})();
